/* HBH Upgrades — bundled JS
   Includes: Quick View modal, free shipping bar updates, sticky nav guard
   ====================================================================== */
(function () {
  'use strict';

  /* ===== QUICK VIEW MODAL (v2 — clean compact layout) ===== */
  let quickViewModal = null;
  let qvProduct = null;

  function ensureModal() {
    if (quickViewModal) return quickViewModal;
    const html = `
      <div class="hbh-qv-modal" id="hbh-qv-modal" role="dialog" aria-modal="true" aria-label="Product quick view">
        <div class="hbh-qv-modal__backdrop"></div>
        <div class="hbh-qv-modal__panel">
          <button class="hbh-qv-modal__close" aria-label="Close quick view" type="button">×</button>
          <div class="hbh-qv-modal__grid">
            <div class="hbh-qv-modal__media">
              <img class="hbh-qv-modal__img" src="" alt="">
            </div>
            <div class="hbh-qv-modal__info">
              <h2 class="hbh-qv-modal__title">Loading…</h2>
              <div class="hbh-qv-modal__price"></div>
              <div class="hbh-qv-modal__variants"></div>
              <div class="hbh-qv-modal__actions">
                <div class="hbh-qv-modal__qty">
                  <button type="button" class="hbh-qv-modal__qty-btn" data-qv-qty="-1" aria-label="Decrease">−</button>
                  <input type="number" class="hbh-qv-modal__qty-input" value="1" min="1" aria-label="Quantity">
                  <button type="button" class="hbh-qv-modal__qty-btn" data-qv-qty="1" aria-label="Increase">+</button>
                </div>
                <button type="button" class="hbh-qv-modal__add" data-qv-add>ADD TO CART</button>
              </div>
              <a class="hbh-qv-modal__details" href="#">View full details →</a>
            </div>
          </div>
        </div>
      </div>`;
    document.body.insertAdjacentHTML('beforeend', html);
    quickViewModal = document.getElementById('hbh-qv-modal');

    quickViewModal.addEventListener('click', (e) => {
      if (e.target.classList.contains('hbh-qv-modal__backdrop') || e.target.closest('.hbh-qv-modal__close')) {
        closeQuickView();
      }
      // qty buttons
      const qtyBtn = e.target.closest('[data-qv-qty]');
      if (qtyBtn) {
        const input = quickViewModal.querySelector('.hbh-qv-modal__qty-input');
        const delta = parseInt(qtyBtn.dataset.qvQty, 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      }
      // add to cart
      if (e.target.closest('[data-qv-add]')) {
        addToCartFromQv();
      }
    });

    quickViewModal.addEventListener('change', (e) => {
      if (e.target.matches('[data-qv-variant-select]')) {
        updateQvVariant(e.target.value);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && quickViewModal && quickViewModal.classList.contains('is-open')) {
        closeQuickView();
      }
    });
    return quickViewModal;
  }

  function fmtMoney(n) {
    return '$' + (Number(n) / 100).toFixed(2);
  }

  function updateQvVariant(variantId) {
    if (!qvProduct) return;
    const v = qvProduct.variants.find(x => String(x.id) === String(variantId)) || qvProduct.variants[0];
    if (!v) return;
    const modal = quickViewModal;
    const price = v.compare_at_price && v.compare_at_price > v.price
      ? `<strong>${fmtMoney(v.price)}</strong> <s class="hbh-qv-modal__strike">${fmtMoney(v.compare_at_price)}</s>`
      : `<strong>${fmtMoney(v.price)}</strong>`;
    modal.querySelector('.hbh-qv-modal__price').innerHTML = price;
    if (v.featured_image && v.featured_image.src) {
      modal.querySelector('.hbh-qv-modal__img').src = v.featured_image.src;
    }
    modal.querySelector('.hbh-qv-modal__add').dataset.variantId = v.id;
    modal.querySelector('.hbh-qv-modal__add').disabled = !v.available;
    modal.querySelector('.hbh-qv-modal__add').textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
  }

  function openQuickView(productHandle) {
    const modal = ensureModal();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    qvProduct = null;
    // reset
    modal.querySelector('.hbh-qv-modal__title').textContent = 'Loading…';
    modal.querySelector('.hbh-qv-modal__price').innerHTML = '';
    modal.querySelector('.hbh-qv-modal__variants').innerHTML = '';
    modal.querySelector('.hbh-qv-modal__img').src = '';
    modal.querySelector('.hbh-qv-modal__img').alt = '';

    fetch(`/products/${productHandle}.js`)
      .then(r => r.json())
      .then(p => {
        qvProduct = p;
        modal.querySelector('.hbh-qv-modal__title').textContent = p.title;
        const img = p.featured_image || (p.images && p.images[0]);
        if (img) {
          modal.querySelector('.hbh-qv-modal__img').src = (typeof img === 'string') ? img : img.src || img;
          modal.querySelector('.hbh-qv-modal__img').alt = p.title;
        }
        // Variants
        const variantsEl = modal.querySelector('.hbh-qv-modal__variants');
        if (p.variants && p.variants.length > 1) {
          // Use the FIRST option (typically Finish/Tips) as the picker
          // p.options can be an array of strings OR array of objects {name, position, values}
          const opt0 = p.options[0];
          const optName = (typeof opt0 === 'string') ? opt0 : (opt0 && opt0.name) ? opt0.name : 'Variant';
          let html = `<label class="hbh-qv-modal__variants-label">${optName}</label><select data-qv-variant-select class="hbh-qv-modal__variants-select">`;
          p.variants.forEach(v => {
            html += `<option value="${v.id}"${v.available ? '' : ' disabled'}>${v.title}${v.available ? '' : ' — Sold out'}</option>`;
          });
          html += '</select>';
          variantsEl.innerHTML = html;
        } else {
          variantsEl.innerHTML = '';
        }
        modal.querySelector('.hbh-qv-modal__details').href = '/products/' + p.handle;
        updateQvVariant((p.variants && p.variants[0] && p.variants[0].id) || '');
      })
      .catch(() => {
        modal.querySelector('.hbh-qv-modal__title').textContent = 'Unable to load product';
      });
  }

  function addToCartFromQv() {
    const modal = quickViewModal;
    const variantId = modal.querySelector('.hbh-qv-modal__add').dataset.variantId;
    const qty = parseInt(modal.querySelector('.hbh-qv-modal__qty-input').value, 10) || 1;
    if (!variantId) return;
    const btn = modal.querySelector('.hbh-qv-modal__add');
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(r => r.json())
      .then(() => {
        btn.textContent = '✓ Added';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          // Open cart drawer if Horizon supports it
          const cartIcon = document.querySelector('cart-drawer, [data-cart-drawer], .cart-drawer__toggle');
          if (cartIcon && cartIcon.show) cartIcon.show();
          else if (cartIcon && cartIcon.click) cartIcon.click();
        }, 800);
      })
      .catch(() => {
        btn.textContent = 'Error — try again';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1500);
      });
  }

  function closeQuickView() {
    if (!quickViewModal) return;
    quickViewModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.hbh-quick-view-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.handle;
    if (handle) openQuickView(handle);
  });

  /* ===== FREE SHIPPING BAR — recompute on cart updates ===== */
  const FREE_SHIPPING_THRESHOLD_CENTS = 29900; // $299

  function updateFreeShippingBar() {
    const bars = document.querySelectorAll('.hbh-free-shipping-bar');
    if (!bars.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const total = cart.total_price; // cents
        const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD_CENTS - total);
        const pct = Math.min(100, (total / FREE_SHIPPING_THRESHOLD_CENTS) * 100);
        bars.forEach((bar) => {
          const fill = bar.querySelector('.hbh-free-shipping-bar__fill');
          const msg = bar.querySelector('.hbh-free-shipping-bar__msg');
          if (fill) {
            fill.style.width = pct + '%';
            fill.classList.toggle('hbh-free-shipping-bar__fill--complete', remaining === 0);
          }
          if (msg) {
            if (remaining === 0) {
              msg.innerHTML = '🎉 <strong>You\'ve unlocked free shipping!</strong>';
            } else {
              const dollars = (remaining / 100).toFixed(2);
              msg.innerHTML = `Add <strong>$${dollars}</strong> more for <strong>FREE shipping</strong>`;
            }
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', updateFreeShippingBar);
  // Re-run after cart updates (Shopify dispatches this on add-to-cart)
  document.addEventListener('cart:updated', updateFreeShippingBar);
  document.addEventListener('cart:refresh', updateFreeShippingBar);
  document.addEventListener('cart:item-added', updateFreeShippingBar);
  // Fallback: re-run periodically when cart drawer is open
  const cartDrawerObserver = new MutationObserver(() => {
    if (document.querySelector('.cart-drawer.is-open, cart-drawer[open]')) {
      updateFreeShippingBar();
    }
  });
  cartDrawerObserver.observe(document.body, { childList: true, subtree: true, attributes: true });

  /* ===== STICKY NAV GUARD — make sure header stays visible ===== */
  function unstickHide() {
    document
      .querySelectorAll('sticky-header.scrolled-down, sticky-header[data-hidden]')
      .forEach((el) => {
        el.classList.remove('scrolled-down');
        el.removeAttribute('data-hidden');
        el.style.transform = 'none';
      });
  }
  window.addEventListener('scroll', () => requestAnimationFrame(unstickHide), { passive: true });

  /* ===== HEADER PHONE LINK — always-visible click-to-call in header ===== */
  const HBH_PHONE_DISPLAY = '1-888-737-6515';
  const HBH_PHONE_TEL = '+18887376515';

  function injectHeaderPhone() {
    if (document.querySelector('.hbh-header-phone')) return; // already added
    // Find the header icons area (where search/account/cart live)
    const header = document.querySelector('sticky-header, .header, header[role="banner"]');
    if (!header) return;
    // Try to find the right-side icon group first
    let target =
      header.querySelector('.header__icons') ||
      header.querySelector('.header-actions') ||
      header.querySelector('.header__actions') ||
      header.querySelector('header-actions') ||
      header.querySelector('.header-right') ||
      header;
    const phone = document.createElement('a');
    phone.className = 'hbh-header-phone';
    phone.href = 'tel:' + HBH_PHONE_TEL;
    phone.setAttribute('aria-label', 'Call us at ' + HBH_PHONE_DISPLAY);
    phone.innerHTML =
      '<svg class="hbh-header-phone__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.92.34 1.83.66 2.7a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.38-1.38a2 2 0 0 1 2.11-.45c.87.32 1.78.54 2.7.66A2 2 0 0 1 22 16.92z" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="hbh-header-phone__num">' + HBH_PHONE_DISPLAY + '</span>';
    // Insert as the FIRST child of icon group (so it appears before search/account/cart)
    if (target.firstChild) {
      target.insertBefore(phone, target.firstChild);
    } else {
      target.appendChild(phone);
    }
  }

  document.addEventListener('DOMContentLoaded', injectHeaderPhone);
  // Re-run on dynamic header re-renders (Horizon sometimes hydrates async)
  setTimeout(injectHeaderPhone, 500);
  setTimeout(injectHeaderPhone, 1500);

  
/* ===== SKU — keyed, copyable box on the brand row (task 3.10.2) =====
     Upgrades the SKU the HBH Product Meta block already renders. That block
     keeps .hbh-meta__sku in sync on variant change, so we MOVE that live span
     into the box rather than copying its text — its sync keeps working. */
  function upgradeSkuBox() {
    var span = document.querySelector('.hbh-meta__brand .hbh-meta__sku');
    if (!span || span.closest('.hbh-idcode')) return;



    var wrap = document.createElement('div');
    wrap.className = 'hbh-idcode';
    var box = document.createElement('div');
    box.className = 'hbh-idcode__box';
    var key = document.createElement('span');
    key.className = 'hbh-idcode__k';
    key.textContent = 'SKU / Model';

    span.parentNode.insertBefore(wrap, span);
    box.appendChild(key);
    box.appendChild(span);
    wrap.appendChild(box);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hbh-idcode__copy';
    btn.title = 'Copy SKU';
    btn.setAttribute('aria-label', 'Copy SKU');
    btn.innerHTML =
      '<svg class="hbh-idcode__i hbh-idcode__i--copy" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' +
      '<svg class="hbh-idcode__i hbh-idcode__i--ok" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    box.appendChild(btn);

    var hint = document.createElement('p');
    hint.className = 'hbh-idcode__hint';
    hint.textContent = 'Quote this for support or reorders.';
    wrap.appendChild(hint);

    var live = document.createElement('span');
    live.className = 'hbh-idcode__sr';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    wrap.appendChild(live);

    var hintWas = hint.textContent;
    var timer = null;

    btn.addEventListener('click', function () {
      var text = (span.textContent || '').trim();
      if (!text) return;

      function done() {
        btn.classList.add('is-ok');
        hint.textContent = 'Copied to clipboard.';
        live.textContent = 'SKU ' + text + ' copied';
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-ok');
          hint.textContent = hintWas;
          live.textContent = '';
        }, 1900);
      }
      function fallback() {
        // Older browsers and non-secure origins have no async clipboard.
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;left:-9999px;opacity:0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        ta.remove();
        done();
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, fallback);
      } else {
        fallback();
      }
    });
  }
  document.addEventListener('DOMContentLoaded', upgradeSkuBox);
  setTimeout(upgradeSkuBox, 600);
  setTimeout(upgradeSkuBox, 1800);



  /* ===== CART DRAWER — move Free Shipping Bar below the totals ===== */
  function repositionFreeShippingBar() {
    const bar = document.querySelector('.hbh-free-shipping-bar');
    if (!bar) return;
    if (bar.dataset.hbhRepositioned === '1') return;
    // Find the totals / checkout area in the cart drawer
    const target =
      document.querySelector('.cart-drawer__footer, .cart__footer, .drawer__footer, [class*="cart-footer"], [class*="cart__totals"]') ||
      document.querySelector('button[name="checkout"], button[type="submit"][name="checkout"], a[href="/checkout"]')?.parentElement;
    if (!target) return;
    bar.dataset.hbhRepositioned = '1';
    bar.classList.add('hbh-free-shipping-bar--bottom');
    // Insert just BEFORE the checkout button area but below the totals
    target.parentNode.insertBefore(bar, target);
  }
  document.addEventListener('DOMContentLoaded', repositionFreeShippingBar);
  setTimeout(repositionFreeShippingBar, 500);
  document.addEventListener('cart:updated', repositionFreeShippingBar);
  document.addEventListener('cart:refresh', repositionFreeShippingBar);
  // Watch for cart drawer open
  const cartDrawerObs = new MutationObserver(() => {
    if (document.querySelector('.cart-drawer.is-open, cart-drawer[open]')) {
      setTimeout(repositionFreeShippingBar, 100);
    }
  });
  cartDrawerObs.observe(document.body, { childList: true, subtree: true, attributes: true });

  /* ===== VARIANT COLOR SWATCHES — paint buttons with finish colors ===== */
  // Map of finish codes/names to hex colors
    const HBH_SWATCH_MAP = {
    /* Grouped by MATERIAL. The same finish word is a different color on an
       anodized aluminum extrusion than it is on solid brass or bronze.
       BRONZE and MILL ALUMINUM measured from product photographs 2026-09-03. */

    // --- anodized aluminum extrusion: thresholds, sweeps, door bottoms ---
    'AL': '#C2C2BC', 'ALUMINUM': '#C2C2BC',
    'MA': '#C2C2BC', 'MILL ALUMINUM': '#C2C2BC', 'MILL FINISH': '#C2C2BC',
    'CA': '#D2D4D0', 'CLEAR ANODIZED': '#D2D4D0',
    'BRONZE': '#8A7A45',
    'ARCHITECTURAL BRONZE': '#6B5A30',
    'DU': '#4A3A22', '690': '#4A3A22', 'DU 690': '#4A3A22',
    'DB': '#4A3A22', 'DARK BRONZE ANODIZED': '#4A3A22',
    'BLACK ANODIZED ALUMINUM': '#2E2C29',

    // --- solid brass & bronze hardware ---
    'US3': '#C9A95A', '605': '#C9A95A', 'POLISHED BRASS': '#C9A95A',
    'PB': '#C9A95A', 'PAINTED BRASS': '#C9A95A',
    'BR': '#C9A95A', 'BRASS': '#C9A95A', 'GOLD': '#C9A95A',
    'US4': '#A5946B', 'SATIN BRASS': '#A5946B',
    'US5': '#745E45', 'ANTIQUE BRASS': '#745E45',
    'FRENCH ANTIQUE': '#6B5744',
    'US10': '#5C3D2E', 'SATIN BRONZE': '#5C3D2E',
    'US10B': '#3D2817', 'OIL RUBBED BRONZE': '#3D2817',
    'US44': '#2D1F15', 'DARK BRONZE': '#2D1F15',
    'BRUSHED BRONZE': '#7A6A55',
    'US17A': '#8E8E8A', 'US17': '#8E8E8A', 'PEWTER': '#8E8E8A',

    // --- plated, chrome, nickel, stainless ---
    'US14': '#D8D8D6', 'POLISHED NICKEL': '#D8D8D6',
    'US15': '#C5C2BE', 'SATIN NICKEL': '#C5C2BE',
    '15A': '#9A9184', 'US15A': '#9A9184', 'ANTIQUE NICKEL': '#9A9184',
    'US26': '#E1E1E1', '625': '#E1E1E1', 'POLISHED CHROME': '#E1E1E1',
    'US26D': '#B2B2B2', '26D': '#B2B2B2', 'BRUSHED CHROME': '#B2B2B2',
    'US32': '#D5D5D5', 'POLISHED STAINLESS': '#D5D5D5',
    'US32D': '#B5B5B5', 'BRUSHED STAINLESS': '#B5B5B5',
    'SS': '#B5B5B5', 'STAINLESS': '#B5B5B5', 'STAINLESS STEEL': '#B5B5B5',

    // --- black ---
    'US19': '#1A1A1A', 'MATTE BLACK': '#1A1A1A', 'BLACK': '#1A1A1A'
  };

  function hbhFindColor(text) {
    if (!text) return null;
    const upper = text.toUpperCase().trim();
    // 1. Exact match
    if (HBH_SWATCH_MAP[upper]) return HBH_SWATCH_MAP[upper];
    // 2. Extract codes inside parens: "Polished Brass (US3/605)" → ["US3","605"]
    const parenMatch = upper.match(/\(([^)]+)\)/);
    if (parenMatch) {
      const codes = parenMatch[1].split('/').map(c => c.trim());
      for (const code of codes) {
        if (HBH_SWATCH_MAP[code]) return HBH_SWATCH_MAP[code];
      }
    }
    // 3. Text before paren — exact
    const beforeParen = upper.split('(')[0].trim();
    if (HBH_SWATCH_MAP[beforeParen]) return HBH_SWATCH_MAP[beforeParen];
    // 4. WORD-BOUNDARY substring match — ONLY for keys 5+ chars (avoid false-positives like "Classroom" matching "SS")
    // Sort keys by length DESC so longer descriptive names match first
    const sortedKeys = Object.keys(HBH_SWATCH_MAP).filter(k => k.length >= 5).sort((a,b) => b.length - a.length);
    for (const key of sortedKeys) {
      try {
        if (new RegExp('\\b' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b').test(upper)) {
          return HBH_SWATCH_MAP[key];
        }
      } catch(e) {}
    }
    return null;
  }

  function paintSwatches() {
    // Target Horizon's variant picker pills/buttons
    const buttons = document.querySelectorAll(
      'variant-picker label, variant-picker .pill, variant-picker [role="radio"], ' +
      '.variant-picker label, .variant-option__pill, ' +
      'variant-picker fieldset > label'
    );
    buttons.forEach(btn => {
      if (btn.dataset.hbhSwatchApplied === '1') return;
      const text = (btn.textContent || btn.querySelector('input')?.value || '').trim();
      const color = hbhFindColor(text);
      if (!color) return;
      btn.dataset.hbhSwatchApplied = '1';
      btn.style.setProperty('--hbh-swatch-color', color);
      btn.classList.add('hbh-swatch-btn');
      btn.setAttribute('title', text);
    });
  }

  document.addEventListener('DOMContentLoaded', paintSwatches);
  setTimeout(paintSwatches, 400);
  setTimeout(paintSwatches, 1200);
  setTimeout(paintSwatches, 2500);

  // Re-paint immediately on any interaction (cover all events Horizon may use)
  ['change','click','input','pointerup'].forEach(ev => {
    document.addEventListener(ev, function (e) {
      if (e.target.closest('variant-picker, .variant-picker')) {
        paintSwatches();
        setTimeout(paintSwatches, 50);
        setTimeout(paintSwatches, 200);
        setTimeout(paintSwatches, 500);
      }
    }, true);
  });

  // MutationObserver — re-paint whenever Horizon re-renders the variant picker subtree
  let hbhSwatchObsThrottle = false;
  const hbhSwatchObs = new MutationObserver(() => {
    if (hbhSwatchObsThrottle) return;
    hbhSwatchObsThrottle = true;
    requestAnimationFrame(() => {
      paintSwatches();
      hbhSwatchObsThrottle = false;
    });
  });
  function attachSwatchObserver() {
    const pickers = document.querySelectorAll('variant-picker, .variant-picker');
    pickers.forEach(p => {
      if (p.__hbhObserved) return;
      p.__hbhObserved = true;
      hbhSwatchObs.observe(p, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','aria-checked','data-selected'] });
    });
  }
  document.addEventListener('DOMContentLoaded', attachSwatchObserver);
  setTimeout(attachSwatchObserver, 800);
  setTimeout(attachSwatchObserver, 2000);

  // Last-resort: also re-clear the "applied" flag so re-painting always happens on re-rendered nodes
  function paintSwatchesForce() {
    document.querySelectorAll('[data-hbh-swatch-applied]').forEach(el => delete el.dataset.hbhSwatchApplied);
    paintSwatches();
  }
  setInterval(paintSwatchesForce, 1500);

  /* ===== ACTIVE FILTER CHIPS — show selected filters at top of product grid ===== */
  function prettifyFilterKey(key) {
    // e.g., "filter.p.m.custom.bearing_type" → "Bearing Type"
    var last = key.split('.').pop() || '';
    return last
      .replace(/[_-]/g, ' ')
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function buildFilterChips() {
    if (!/\/collections\//.test(location.pathname)) return;
    var grid = document.querySelector('results-list, product-grid, .product-grid, [class*="product-grid"]');
    if (!grid) return;

    var chipBar = document.getElementById('hbh-filter-chips');
    if (!chipBar) {
      chipBar = document.createElement('div');
      chipBar.id = 'hbh-filter-chips';
      chipBar.className = 'hbh-filter-chips';
      grid.parentNode.insertBefore(chipBar, grid);
    }

    var url = new URL(location.href);
    var entries = [];
    url.searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) entries.push([key, value]);
    });

    chipBar.innerHTML = '';
    if (entries.length === 0) { chipBar.style.display = 'none'; return; }
    chipBar.style.display = '';

    var label = document.createElement('span');
    label.className = 'hbh-filter-chips__label';
    label.textContent = 'Filtered by:';
    chipBar.appendChild(label);

    entries.forEach(function (e) {
      var key = e[0], value = e[1];
      var chip = document.createElement('a');
      chip.className = 'hbh-filter-chips__chip';
      var newUrl = new URL(location.href);
      // Multi-value handling: drop only this specific value
      var allValues = newUrl.searchParams.getAll(key);
      newUrl.searchParams.delete(key);
      allValues.forEach(function (v) {
        if (v !== value) newUrl.searchParams.append(key, v);
      });
      chip.href = newUrl.toString();
      chip.setAttribute('aria-label', 'Remove filter ' + prettifyFilterKey(key) + ': ' + value);
      chip.innerHTML =
        '<span class="hbh-filter-chips__name">' + prettifyFilterKey(key) + ': ' + value + '</span>' +
        '<span class="hbh-filter-chips__x" aria-hidden="true">×</span>';
      chipBar.appendChild(chip);
    });

    var clear = document.createElement('a');
    clear.className = 'hbh-filter-chips__clear';
    clear.textContent = 'Clear all';
    var clearUrl = new URL(location.href);
    var keysToRemove = [];
    clearUrl.searchParams.forEach(function (_, k) {
      if (k.indexOf('filter.') === 0) keysToRemove.push(k);
    });
    keysToRemove.forEach(function (k) { clearUrl.searchParams.delete(k); });
    clear.href = clearUrl.toString();
    chipBar.appendChild(clear);
  }

  document.addEventListener('DOMContentLoaded', buildFilterChips);
  window.addEventListener('popstate', buildFilterChips);
  setTimeout(buildFilterChips, 500);
  setTimeout(buildFilterChips, 1500);
  // Re-render when Horizon updates filters via AJAX
  document.addEventListener('shopify:section:load', buildFilterChips);
  document.addEventListener('change', function (e) {
    if (e.target.closest('facet-filters, .facets, .filters')) {
      setTimeout(buildFilterChips, 300);
    }
  });

  /* ===== ANNOUNCEMENT BAR VISIBILITY TRACKER =====
     Toggle body.hbh-announcement-hidden when the top trust bar / announcement
     bar is no longer visible in the viewport. CSS uses this to show the
     in-header phone link only when the top phone is out of view. */
  function setupAnnouncementWatcher() {
    const bar =
      document.querySelector('.announcement-bar') ||
      document.querySelector('announcement-bar') ||
      document.querySelector('.hbh-trust-band') ||
      document.querySelector('.shopify-section-announcement-bar') ||
      document.querySelector('[class*="announcement"]');
    if (!bar) {
      // No announcement bar? Always show the header phone
      document.body.classList.add('hbh-announcement-hidden');
      return;
    }
    // IntersectionObserver: triggers when bar enters/leaves the viewport
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            document.body.classList.remove('hbh-announcement-hidden');
          } else {
            document.body.classList.add('hbh-announcement-hidden');
          }
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );
    io.observe(bar);
  }
  document.addEventListener('DOMContentLoaded', setupAnnouncementWatcher);
  setTimeout(setupAnnouncementWatcher, 800);
})();





/* Highlight the current product's column in the Bear comparison table.
   The table lives in a shadow root, so CSS must be injected into it. */
(function () {
  var CSS = [
    '.row--attribute > *:nth-child(2){ background:#faf7f0; }',
    '.row--product > *:nth-child(2)::before{',
    '  content:"CURRENTLY VIEWING"; display:block;',
    '  margin:0 -12px 10px; padding:7px 12px;',
    '  background:#faf7f0; text-align:center;',
    '  font-size:10px; font-weight:700; letter-spacing:.09em;',
    '  color:#222; }'
  ].join('\n');

  function paint() {
    document.querySelectorAll('sc-comparison-table').forEach(function (el) {
      var sr = el.shadowRoot;
      if (!sr || sr.getElementById('hbh-current-col')) return;
      var s = document.createElement('style');
      s.id = 'hbh-current-col';
      s.textContent = CSS;
      sr.appendChild(s);
    });
  }

  paint();
  document.addEventListener('DOMContentLoaded', paint);
  document.addEventListener('shopify:section:load', paint);
  [200, 600, 1500, 3000].forEach(function (t) { setTimeout(paint, t); });
})();